<template>
  <div>
    <div class="selectsearch relative">
      <input
        class="
          appearance-none
          w-full
          bg-transparent
          border
          py-3
          px-4
          pr-10
          rounded
          leading-tight
          focus:outline-none
          cursor-pointer
        "
        :class="
          type == 'login'
            ? 'border-gray-300 placeholder-menu-text-black'
            : 'placeholder-menu-text-color  border-menu-text-color'
        "
        type="text"
        @input="onChange"
        v-model="search"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @click="showDropdown"
        :placeholder="___('General|User Search|content') + '...'"
      />
      <div
        class="search-icons absolute inset-y-0 right-0 flex items-center px-2"
      >
        <svg
          :class="search ? 'block' : 'hidden'"
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="clearSearch"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <svg
          class="fill-current h-4 w-4 cursor-pointer"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          :class="
            selectClicked == true
              ? 'transform rotate-180'
              : ' transform rotate-0'
          "
          @click="showDropdown"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
      <ul
        id="selectsearch-list"
        v-show="isOpen"
        class="
          selectsearch-list
          list-none
          border
          overflow-auto
          absolute
          z-10
          bg-white
          text-black
          w-full
        "
      >
        <li class="loading" v-if="isLoading">
          {{ ___("General|Loading results|content") + "..." }}
        </li>
        <li
          v-else-if="results.length > 0"
          v-for="(result, i) in results"
          :key="i"
          @click="setResult(result)"
          class="selectsearch-result px-3 py-2 cursor-pointer"
          :class="{ 'is-active': i === arrowCounter }"
        >
          {{ result.name }}
          ({{ $page.props.mainAccountCanUseUserSwitcher ? result.main_account :  result.main_account_name  }})
          
          <template v-if="displayCustomAttributeValue(result, userSwitcherSlot1) !== ''">
            ({{ displayCustomAttributeValue(result, userSwitcherSlot1) }})
          </template>

          <template v-if="displayCustomAttributeValue(result, userSwitcherSlot2) !== ''">
            ({{ displayCustomAttributeValue(result, userSwitcherSlot2) }})
          </template>

        </li>
        <li v-else class="px-3 py-2">
          {{ ___("General|MultiSelectError|content") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Btn from "@/Components/Btn";

export default {
  name: "SearchSelect",
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: String,
  },
  components: {
    Btn,
  },
  data() {
    return {
      isOpen: false,
      results: this.items,
      search: "",
      searchId: "",
      isLoading: false,
      arrowCounter: -1,
      selectClicked: false,
      selectedUser: "",
      userSwitcherSlot1 : this.$page.props.userSwitcherSlot1,
      userSwitcherSlot2 : this.$page.props.userSwitcherSlot2,
    };
  },
  watch: {
    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.results = value;
        this.isLoading = false;
      }
    },
  },
  methods: {
    showDropdown() {
      this.isOpen = !this.isOpen;
      this.selectClicked = !this.selectClicked;
    },
    setResult(result) {
      this.search = result.name;
      this.searchId = result.id;

      this.isOpen = false;
      this.selectedUser = this.searchId;
      this.$emit('selected-user', this.selectedUser);
    },
    filterResults() {
      this.results = this.items.filter((item) => {
        const nameMatch = item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        const accountNameMatch = item.main_account_name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;

        const userSwitcherSlot1Key = this.$page.props.userSwitcherSlot1;
        const userSwitcherSlot2Key = this.$page.props.userSwitcherSlot2;

        let customAttributesMatch = false;

        customAttributesMatch = JSON.parse(item.customAttributes).some((attribute) => {
            if (
              (attribute.attributeDefinitionId === userSwitcherSlot1Key && userSwitcherSlot1Key !== 'do_not_use' && attribute.stringValue) ||
              (attribute.attributeDefinitionId === userSwitcherSlot2Key && userSwitcherSlot2Key !== 'do_not_use' && attribute.stringValue)
            ) {
              return attribute.stringValue.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            }
            return false;
          });

        return nameMatch || accountNameMatch || customAttributesMatch;
      });
    },
    onChange() {
      if (this.isAsync) {
        this.isLoading = true;
      } else {
        this.filterResults();
        this.isOpen = true;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.search = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    clearSearch() {
      this.search = "";
      this.searchId = "";
      this.selectedUser = this.searchId;
      this.results = this.items;
      this.$emit('selected-user', this.selectedUser);
    },
    displayCustomAttributeValue($item,$key){
      if($key == 'do_not_use'){
        return '';
      }
      else{
        const customAttributeFound = JSON.parse($item.customAttributes).find((attribute) => {
          return attribute.attributeDefinitionId === $key && attribute.stringValue;
        });
        return customAttributeFound ? customAttributeFound.stringValue : "";
      }
    }
  },
};
</script>